import UAParser from 'ua-parser-js';

const _sanitizeValue = function (value) {
  return (value || '').replace(/ /g, '').toLowerCase();
};

export default class UserAgent {
  constructor() {
    const parser = new UAParser();
    this.result = parser.getResult();
  }

  getOSName() {
    return _sanitizeValue(this.result.os.name);
  }

  getBrowserName() {
    return _sanitizeValue(this.result.browser.name);
  }

  getBrowserVersion() {
    return _sanitizeValue(this.result.browser.version);
  }

  getDeviceType() {
    return _sanitizeValue(this.result.device.type);
  }

  isTouch() {
    return this.result.device && (this.result.device.type === 'tablet' || this.result.device.type === 'mobile');
  }
}
